class BestSellerShowcase extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('[data-bss-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-bss-panel]'));
  }

  connectedCallback() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.setActiveTab(tab.dataset.bssTab));
    });

    this.querySelectorAll('[data-bss-wishlist], [data-plp-wishlist]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        button.classList.toggle('is-active');
        button.setAttribute('aria-pressed', button.classList.contains('is-active'));
      });
    });

    this.trackUpdaters = new Map();

    this.querySelectorAll('[data-bss-track]').forEach((track) => {
      const prev = track.parentElement.querySelector('[data-bss-prev]');
      const next = track.parentElement.querySelector('[data-bss-next]');
      const cardWidth = () => track.querySelector('[data-bss-card]')?.getBoundingClientRect().width || 0;

      const updateArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 1);
        if (next) next.classList.toggle('is-hidden', track.scrollLeft >= maxScroll - 1);
      };

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: cardWidth(), behavior: 'smooth' }));

      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      this.trackUpdaters.set(track, updateArrows);
      updateArrows();
    });
  }

  setActiveTab(tabHandle) {
    this.tabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.bssTab === tabHandle);
    });
    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.bssPanel === tabHandle);
    });

    const activeTrack = this.querySelector(`[data-bss-panel="${tabHandle}"] [data-bss-track]`);
    const updateArrows = activeTrack && this.trackUpdaters.get(activeTrack);
    if (updateArrows) requestAnimationFrame(updateArrows);
  }
}

customElements.define('best-seller-showcase', BestSellerShowcase);
